import { call, put } from 'redux-saga/effects';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { logoutRequest } from 'store/auth/actions';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { renderErrorMessage } from 'utils/render-error-message';
import { MessageStates } from 'containers/MessageBox';
import { loadReconRequest } from 'store/vat/actions';
import { updateOrganisationTotalTaxBalance } from 'store/organisation/actions';

import {
  updateOrganisationTaxBalanceFailure,
  updateOrganisationTaxBalanceSuccess,
} from '../actions';
import { updateOrganisationTaxBalance } from '../api';
import { UpdateOrganisationTaxBalanceRequestAction } from '../types';
import i18n from 'i18next';

export function* updateOrganisationTaxBalanceSaga(
  action: UpdateOrganisationTaxBalanceRequestAction
) {
  const { organisationId, taxBalance, refreshRecon } = action.payload;

  try {
    const updateResponse: ApiResponse = yield call(
      updateOrganisationTaxBalance,
      organisationId,
      taxBalance
    );

    const err: ApiError | null = checkResponse(updateResponse?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: updateResponse.responseMessage.message,
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
    yield put(updateOrganisationTaxBalanceSuccess());
    yield put(updateOrganisationTotalTaxBalance(organisationId, taxBalance));

    // If requested, refresh the current VAT reconciliation run.
    if (refreshRecon) {
      yield put(
        loadReconRequest(
          refreshRecon.tokenId,
          refreshRecon.toDate,
          refreshRecon.mappingId,
          refreshRecon.asAtDate,
          refreshRecon.currency
        )
      );
    }
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(updateOrganisationTaxBalanceFailure(error?.message));
  }
}

